import utils from '@/app/utils/gfUtils';

(function (jQuery) {
  jQuery.gfSettingsPopup = function (element, options) {
    const defaults = {
      onSelected: function () {},
    };

    this.settings = {};
    const $element = $(element);

    const _this = this;

    let _isPreview = false;

    /* Editor */
    const $gfLeftSideBar = jQuery('#gfLeftSideBar');

    /* Iframe */
    const $gfFrame = jQuery('#gfFrame');
    const $gryffEditor = $gfFrame.contents().find('.gryffeditor').first();
    const $gryffBody = $gfFrame.contents().find('body').first();

    this.init = function () {
      this.settings = jQuery.extend({}, defaults, options);
      $element.hide();
      if ($element.hasClass('gf_to-cookie-popup')) {
        _this.setTemplateCookie();
      }
      if ($element.hasClass('gf_to-preview-popup')) {
        _this.setTemplatePreview();
      }
      return false;
    };

    this.setTemplatePreview = function () {
      const _template = '<a id="gf-preview-popup">Preview</a>';
      $element.after(_template);

      const $previewPopup = $element.next('#gf-preview-popup');

      const merId = $gfLeftSideBar.find('#md-settings').data('edittingID');
      const $targetElement = $gryffBody.find('#' + merId);
      const moduleId = $targetElement.data('gfmodule').getModuleId();
      const moduleIdSlug = moduleId.toString().replace(/-/g, '');
      const func = 'getPopup' + moduleIdSlug;

      $previewPopup.off('click.preview').on('click.preview', function () {
        if (_isPreview) {
          // Stop
          _isPreview = false;
          $previewPopup.text('Preview');
          if (document.getElementById('gfFrame').contentWindow[func]) {
            document.getElementById('gfFrame').contentWindow[func]().hide();
          }
        } else {
          // Start
          _isPreview = true;
          $previewPopup.text('Stop');
          const action = $gfLeftSideBar.find('[name="trigger"]').attr('value');
          switch (action) {
            case 'afterAFewSeconds':
            case 'scrollBottom':
            case 'userExit':
            case 'scroll':
              if (document.getElementById('gfFrame').contentWindow[func]) {
                document.getElementById('gfFrame').contentWindow[func]().preview(action);
              }
              break;
          }

          // Event off preview popup;
          $gryffEditor.off('popup-hidePreview').on('popup-hidePreview', function () {
            _isPreview = false;
            $previewPopup.text('Preview');
            if ($targetElement.data('gfmodule') != undefined) {
              $targetElement.data('gfmodule').openModuleSettings();
            }
          });
        }
      });
    };
    this.setTemplateCookie = function () {
      const _template = '<a id="gf-cookie-popup">' + utils.svgIcon('reset') + ' Reset Cookie</a>';
      $element.after(_template);

      const $cookiePopup = $element.next('#gf-cookie-popup');

      $cookiePopup.off('click.preview').on('click.preview', function () {
        const $this = jQuery(this);
        $this.html(
          '<svg viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" class="lds-rolling" style="background: none;"><circle cx="50" cy="50" fill="none" ng-attr-stroke="{{config.color}}" ng-attr-stroke-width="{{config.width}}" ng-attr-r="{{config.radius}}" ng-attr-stroke-dasharray="{{config.dasharray}}" stroke="#c7c7c7" stroke-width="10" r="35" stroke-dasharray="164.93361431346415 56.97787143782138" transform="rotate(107.938 50 50)"><animateTransform attributeName="transform" type="rotate" calcMode="linear" values="0 50 50;360 50 50" keyTimes="0;1" dur="1s" begin="0s" repeatCount="indefinite"></animateTransform></circle></svg>',
        );
        const a = '0123456789';
        const b = 'abcdefghijklmnopqrstuvwxyz';
        const random =
          Date.now() + b.charAt(Math.floor(Math.random() * b.length)) + a.charAt(Math.floor(Math.random() * a.length));

        $element.attr('value', random).val(random).trigger('input-change');
        setTimeout(function () {
          $this.html(utils.svgIcon('reset') + ' Reset Cookie');
        }, 1000);
      });
    };

    this.init();
  };
  jQuery.fn.gfSettingsPopup = function (options) {
    return this.each(function () {
      if (undefined == jQuery(this).data('gfsettingspopup')) {
        const plugin = new jQuery.gfSettingsPopup(this, options);
        jQuery(this).data('gfsettingspopup', plugin);
      }
    });
  };
})(jQuery);
